import * as React from 'react';
import { BaSeCheckbox, BaSeCheckboxProps } from '../input/checkbox/checkbox';
import {
  CheckboxContent,
  SelectableContainer,
} from './selectable-container-styled';

interface SelectableContainerProps {
  inputProps: Partial<BaSeCheckboxProps>;
  borderRadius?: string | number;
  renderContent: (selected: boolean) => JSX.Element;
}

export const BaSeSelectableContainer: React.FC<SelectableContainerProps> = ({
  inputProps,
  borderRadius = 12,
  renderContent,
}) => {
  const { checked, disabled, shape, onChange } = React.useMemo(
    () => inputProps,
    [inputProps],
  );

  return (
    <SelectableContainer
      isSelected={!!checked}
      disabled={disabled}
      borderRadius={borderRadius}
      type="button"
      onClick={() => onChange?.(!checked)}
    >
      {renderContent(!!checked)}
      <CheckboxContent>
        <BaSeCheckbox checked={checked} shape={shape} disabled={disabled} />
      </CheckboxContent>
    </SelectableContainer>
  );
};

BaSeSelectableContainer.displayName = 'BaSeSelectableContainer';
